import styled from 'styled-components';

const TimerStyled = styled.div`
  font-weight: 700;
  border: 1px solid var(--color-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  float: right;
`;

export default TimerStyled;
